/*
 * Project: BookingEngine
 * Module: components/booking/rooms/RoomBoardTab.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';

import BoardTooltip from './BoardTooltip';

class RoomBoardTab extends React.Component {
  getMinNightPrice() {
    const amount = this.props.amountStr;
    return this.context.t("<span>From </span><b class='price-value'>{amount}</b><span> per night</span>", { amount });
  }

  render() {
    const { board, lang, isSelected } = this.props;
    return (
      <li className={`board-item md:flex-grow-default ${isSelected ? 'active' : ''}`}
        onClick={() => this.props.onBoardSelect(board)}>
        <BoardTooltip board={board} lang={lang} />
        {/* eslint-disable react/no-danger */}
        <div className="board-item__price" dangerouslySetInnerHTML={{ __html: this.getMinNightPrice() }} />
        {/* eslint-enable react/no-danger */}
      </li>
    );
  }
}

RoomBoardTab.propTypes = {
  amountStr: PropTypes.string.isRequired,
  board: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  lang: PropTypes.string.isRequired,
  onBoardSelect: PropTypes.func.isRequired,
};

RoomBoardTab.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

export default RoomBoardTab;
